'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { isOtPerfEnabled, OT_CONSENT_COOKIE_NAME } from '@ab-inbev-eu/utils/onetrust';

import { getCookie } from '../utils/functions.client';
import { publicConfig } from '../utils/config';

const { IS_DEV_MODE, DATADOG, ENVIRONMENT, BUILD_VERSION, APP_COUNTRY, APP_NAME } = publicConfig();

export default function DatadogConnector() {
  const initDatadog = () => {
    if (
      !datadogRum.getInitConfiguration() &&
      !IS_DEV_MODE &&
      DATADOG.APPLICATION_ID &&
      DATADOG.CLIENT_TOKEN &&
      isOtPerfEnabled(decodeURIComponent(getCookie(OT_CONSENT_COOKIE_NAME) ?? ''))
    ) {
      if (APP_COUNTRY) datadogRum.setGlobalContextProperty('app_country', APP_COUNTRY);
      if (APP_NAME) datadogRum.setGlobalContextProperty('dtc_app_name', APP_NAME);

      datadogRum.init({
        applicationId: DATADOG.APPLICATION_ID,
        clientToken: DATADOG.CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: DATADOG.SERVICE,
        env: ENVIRONMENT,
        version: BUILD_VERSION,
        sessionSampleRate: DATADOG.SESSION_SAMPLE_RATE,
        sessionReplaySampleRate: DATADOG.SESSION_REPLAY_SAMPLE_RATE,
        trackUserInteractions: DATADOG.TRACK_USER_INTERACTION,
        trackResources: DATADOG.TRACK_RESOURCES,
        trackLongTasks: DATADOG.TRACK_LONG_TASKS,
        defaultPrivacyLevel: DATADOG.DEFAULT_PRIVACY_LEVEL,

        allowedTracingUrls: DATADOG.ENABLE_RUM_TRACING ? [(url) => url.startsWith(window.location.origin)] : undefined,
      });
    }
  };

  useEffect(() => {
    initDatadog();
    window.addEventListener('consent.onetrust', initDatadog);
    return () => {
      window.removeEventListener('consent.onetrust', initDatadog);
    };
  }, []);

  return null;
}
